import request from '@/utils/request'

export function getListDebitAccount(query) {
  return request({
    url: '/config-service/v1/debit-account/list',
    method: 'get',
    params: query
  })
}
